<template>
  <div class="chapterCard">
    <div class="cc_title">{{ data.title }}</div>
    <div class="cc_box">
      <div
        class="cc_b_item"
        v-for="(item, index) in data.allClass"
        :key="index"
      >
        <div class="cc_b_i_image">
          <el-image
            style="width: 100%;height: 100%;"
            :src="
              require('../../../../assets/icon/pocAiClassroom/classImage.png')
            "
          ></el-image>
          <span v-text="item.title"></span>
        </div>

        <div class="cc_b_i_message">
          <div>
            <span v-if="item.isComplete">✅已完成</span>
            <span v-else>🏷️待完成</span>
          </div>
          <div>
            <div>
              {{ subjectList.find(i => i.value === item.subject).label }}
            </div>
          </div>
        </div>
        <div class="cc_b_i_btnArea">
          <span
            class="cc_b_i_ba_goClass"
            v-if="[0].includes(item.type)"
            @click.stop="goClass(item)"
            >去上课</span
          >
          <span
            class="cc_b_i_ba_doWorks"
            v-if="[0, 1].includes(item.type)"
            @click.stop="goWorks(item,index)"
            >做练习</span
          >
        </div>
        <!-- <div class="cc_b_i_image">
					<el-image style="width: 100%;height: 100%;" :src="item.image" fit="cover"></el-image>
					<div class="cc_b_i_btnArea">
						<span class="cc_b_i_ba_goClass" v-if="[0].includes(item.type)" @click.stop="goClass(item)">去上课</span>
						<span class="cc_b_i_ba_doWorks" v-if="[0,1].includes(item.type)" @click.stop="goWorks(item)">做练习</span>
					</div>
				</div>
        <div class="cc_b_i_title">
          <el-tooltip
            class="item"
            effect="light"
            :content="item.title"
            placement="top"
          >
            <span v-text="item.title"></span>
          </el-tooltip>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    subjectList: {
      type: Array,
      default: () => []
    },
		index:{
			type:Number,
			default:0
		}
  },
  data() {
    return {
      userId: this.$route.query.userid,
      org: this.$route.query.org,
      oid: this.$route.query.oid
    };
  },
  methods: {
    goClass(item) {
			this.$router.push(
          `/pocClass?userid=${this.userId}&org=${this.org}&oid=${this.oid}`
        );
    },
    goWorks(item,index) {
      this.$router.push(
        `/pocDoTask?userid=${this.userId}&org=${this.org}&oid=${this.oid}&type=${this.index}-${index}`
      );
    }
  }
};
</script>

<style scoped>
.chapterCard {
  width: 100%;
  height: auto;
  margin-top: 30px;
  position: relative;
}

.cc_title {
  margin: 20px 0;
  font-size: 30px;
}

.cc_box {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.cc_b_item {
  width: 250px;
  height: 190px;
  margin-right: 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  background-color: #fff;
  padding: 16px;
  border-radius: 6px;
  border: 2px solid #f0f2f5;
  position: relative;
  transition: 0.3s;
}

.cc_b_item:hover>.cc_b_i_image{
	opacity: .5;
}

.cc_b_item:hover {
  border-color: #3681fc;
  box-shadow: 0px 8px 10px -5px #00000014;

  box-shadow: 0px 16px 24px 2px #0000000a;

  box-shadow: 0px 6px 30px 5px #0000000d;
}

.cc_b_item:hover > .cc_b_i_btnArea {
  display: flex;
}

.cc_b_i_image {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
	opacity: 1;
	transition: .3s;
}

.cc_b_i_image > span {
  position: absolute;
  font-size: 20px;
  color: black;
  display: block;
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}

.cc_b_i_message {
  width: 100%;
  height: 45px;
  display: flex;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cc_b_i_message > div > span {
  font-size: 18px;
  display: flex;
  align-items: center;
}

.cc_b_i_message > div > div {
  font-size: 16px;
  padding: 5px;
  background-color: #e0eafb;
  border-radius: 3px;
  color: #3681fc;
  font-weight: bold;
}

.cc_b_i_btnArea {
  width: 100%;
  height: 45px;
  position: absolute;
  bottom: 16px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  display: none;
}

.cc_b_i_btnArea > span {
  flex: 1;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  color: black;
  /* background-image: radial-gradient(73% 147%, #EADFDF 59%, #ECE2DF 100%), radial-gradient(91% 146%, rgba(255,255,255,0.50) 47%, rgba(0,0,0,0.50) 100%); */
  background-color: #f0f2f5;
  border: solid 2px #f0f2f5;
  box-sizing: border-box;
  font-size: 18px;
  transition: 0.3s;
}

.cc_b_i_btnArea > span:hover {
  color: #3681fc;
  border-color: #e0eafb;
}

.cc_b_i_btnArea > span:nth-of-type(2n) {
  margin-left: 10px;
}

/* .cc_b_item:hover .cc_b_i_image>.cc_b_i_btnArea{
	display: flex;
} */

/* .cc_b_i_image {
  width: 100%;
  height: 260px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
	position: relative;
}

.cc_b_i_btnArea{
	width: 100%;
	height: 50px;
	position: absolute;
	bottom: 5px;
	display: none;
	justify-content: space-around;
	align-items: center;
	padding: 0 10px;
	box-sizing: border-box;
	
} */

/* .cc_b_i_btnArea>span:nth-of-type(2n){
	margin-left: 10px;
}

.cc_b_i_title {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cc_b_i_title > span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/pocAiClassroom/component/chapterCard.vue